import { z } from "zod";
import { patchOf } from "../common/patch.js";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { privacyTextKindSchema, privacyTextStatusSchema } from "./enums.js";
/**
 * Sürümlü KVKK metinleri (ADR 0017 §7): aydınlatma, açık rıza (amaç kodlu) ve ticari ileti onayı. Yeni sürüm yeni
 * satırdır (`revision` = tür + amaç başına en büyük + 1); taslak düzenlenir, yayımlanınca DEĞİŞMEZ (veritabanı
 * tetikleyicisi). Yayımlama aynı tür + amaçtaki yürürlükteki sürümü AYNI transaction'da yürürlükten kaldırır.
 */
export const PRIVACY_PURPOSE_CODE_PATTERN = /^[A-Z][A-Z0-9_]{1,39}$/;
export const PRIVACY_TEXT_LANGUAGES = ["tr", "en"];
export const privacyTextSchema = z.object({
    id: uuidSchema,
    kind: privacyTextKindSchema,
    purposeCode: z.string().nullable().describe("Açık rıza amaç kodu (LOYALTY_PROFILING, DRIVER_APP_LINK…)"),
    revision: z.number().int().describe("Sürüm numarası (1, 2, …)"),
    title: z.string(),
    body: z.string(),
    language: z.enum(PRIVACY_TEXT_LANGUAGES),
    status: privacyTextStatusSchema,
    publishedAt: timestampSchema.nullable(),
    publishedBy: uuidSchema.nullable(),
    retiredAt: timestampSchema.nullable(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
    version: z.number().int(),
});
export const privacyTextListSchema = z.object({ items: z.array(privacyTextSchema) });
export const listPrivacyTextsQuerySchema = z.object({
    kind: privacyTextKindSchema.optional(),
    purposeCode: z.string().regex(PRIVACY_PURPOSE_CODE_PATTERN).optional(),
    status: privacyTextStatusSchema.optional(),
});
const textContent = {
    title: z.string().trim().min(3).max(200),
    body: z.string().trim().min(20, "Metin en az 20 karakter olmalıdır").max(50_000),
    language: z.enum(PRIVACY_TEXT_LANGUAGES).default("tr"),
};
export const createPrivacyTextSchema = z
    .object({
    kind: privacyTextKindSchema,
    purposeCode: z
        .string()
        .trim()
        .regex(PRIVACY_PURPOSE_CODE_PATTERN, "Amaç kodu büyük harf, rakam ve _ içerir (ör. LOYALTY_PROFILING)")
        .nullable()
        .default(null),
    ...textContent,
})
    .refine((value) => (value.kind === "EXPLICIT_CONSENT") === (value.purposeCode !== null), {
    path: ["purposeCode"],
    message: "Amaç kodu yalnızca açık rıza metninde ve orada zorunludur",
});
export const updatePrivacyTextSchema = patchOf(z.object(textContent)).extend({
    version: z.number().int().positive(),
});
export const publishPrivacyTextSchema = z.object({ version: z.number().int().positive() });
//# sourceMappingURL=texts.js.map